export default "__VITE_ASSET__CggRkSzT__"